module.exports = __webpack_public_path__ + "static/img/favicon.f8eaa56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/favicon.png
// module id = 5cf2
// module chunks = 0